<template>
  <div>
    <el-dialog
      title="提示"
      :visible.sync="dialogVisible"
      width="400px"
      :modal="false"
      :close-on-click-modal="false"
    >
      <span>
        <iframe
          style="width: 100%; height: 500px"
          src="https://keyue.cloud.baidu.com/unit/experience?token=1f16a048-6b7a-4b90-88ef-fa8e96908c5c"
          frameborder="0"
        ></iframe>
      </span>
      <i class="el-icon-close close-btn" @click="dialogVisible = false"></i>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="dialogVisible = false"
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "FrontWebAIdialogue",

  data() {
    return {
      dialogVisible: false,
    };
  },

  mounted() {},

  methods: {
    init() {
      this.dialogVisible = true;
    },
  },
};
</script>
<style lang="scss" scoped>
.close-btn{
  position: absolute;
  right: 20px;
  top: 20px;
  color: #fff;
  font-size: 20px;
  cursor: pointer;
}
::v-deep .el-dialog {
  position: fixed !important;
  right: 20px;
  bottom: 20px;
  margin: 0;
  width: auto;
  height: auto;
  border-radius: 20px 20px 0 0;
}
::v-deep .el-dialog__header {
  height: 40px;
  display: none;
  padding: 0 !important;
  position: relative;
  .el-dialog__title {
    display: none;
  }
  .el-dialog__headerbtn {
    top: 50%;
    transform: translate(0, -50%);
  }
}
::v-deep .el-dialog__footer {
  display: none;
}
::v-deep .el-dialog__body {
  // padding: 0px 20px 0 20px;
  padding: 0px;
  border-radius: 15px 15px 0 0;
  overflow: hidden;
  position: relative;
}
</style>
